import React, { useState, useEffect, useCallback } from 'react';
import { FiChevronLeft, FiChevronRight, FiRefreshCw } from 'react-icons/fi';
import getScoreTextKulturSelbtest from '../../../utils/getScoreTextKulturSelbtest copy';
// import chartRiskCultureReadinessScoreOrange from '../../../assets/background-KI-Aktuell.png';
import RadarChart from './Radar';
import getScoreText from '../../../utils/getScoreText';
import chartCultureReadinessScoreOrange from '../../../assets/bg-radar-chart3.png';
import chartCultureReadinessScorev2 from '../../../assets/bg-radar-chart-v2.png';
import chartRiskCultureReadinessScoreOrange from '../../../assets/bg-radar-chart2.png';
import chartBackgroundSpiritHochDreiPink from '../../../assets/bg-radar-chart-pink.png';

import {
  Wrap,
  Container,
  ChartContainer,
  LeftContainer,
  TextContainer,
  Header,
  HeaderLine,
  Score,
  Body,
  BodyLine,
  RefreshButton,
  ButtonLeft,
  ButtonRight,
  BottomContainer,
  BoxFooter,
  SvgWrapper,
  ChartWrapper,
  SubTitle,
  LegendContainer,
  Footer,
} from './styles';

import api from '../../../services/api';

interface Topic {
  name: string;
  category: string;
  score: number;
  questionId?: number;
  topics?: Topic[];
}

interface Props {
  surveyId: number;
  resultId?: number;
  pinkBackground?: boolean;
  radarType?: string;
}

const benchmarkCRS = [69, 75, 73, 73, 70];
const benchmarkRCRS = [74, 81, 66, 70, 50];

const RadarContainer: React.FC<Props> = props => {
  const [structure, setStructure] = useState<Topic[]>([]);
  const [currentAPillar, setCurrentAPillar] = useState<Topic>();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [forceUpdateValue, setForceUpdateValue] = useState(0);
  const [imageBackGround, setImageBackGround] = useState('');

  useEffect(() => {
    if (props.pinkBackground) {
      setImageBackGround(`${chartBackgroundSpiritHochDreiPink}`);
    } else if (currentAPillar?.name === 'Culture Readiness Score') {
      setImageBackGround(
        props.radarType === 'radar_v2'
          ? `${chartCultureReadinessScorev2}`
          : `${chartCultureReadinessScoreOrange}`,
      );
    } else {
      setImageBackGround(`${chartRiskCultureReadinessScoreOrange}`);
    }

    const url = props.resultId
      ? `/results/${props.resultId}/survey/${props.surveyId}/scoreResults`
      : `/results/survey/${props.surveyId}/scoreResults`;

    api.get(url).then(response => {
      setStructure(response.data);
      setCurrentAPillar(response.data[currentIndex]);
    });
  }, [forceUpdateValue, currentIndex, props, currentAPillar?.name]);

  const handleRefresh = useCallback(() => {
    setForceUpdateValue(forceUpdateValue + 1);
  }, [forceUpdateValue]);

  const handlePrev = useCallback(() => {
    setCurrentAPillar(structure[currentIndex - 1]);
    setCurrentIndex(currentIndex - 1);
  }, [structure, currentIndex]);

  const handleNext = useCallback(() => {
    setCurrentAPillar(structure[currentIndex + 1]);
    setCurrentIndex(currentIndex + 1);
  }, [structure, currentIndex]);

  const LegendItem = ({ color, label }): any => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <span
        style={{
          display: 'inline-block',
          width: 40,
          height: 7,
          background: color,
          borderRadius: 2,
          marginRight: 4,
        }}
      />
      <span style={{ color: '#7F7F7F', fontWeight: 500, fontSize: 25 }}>
        {label}
      </span>
    </div>
  );

  return (
    <Wrap id="wrap">
      {!props.resultId && (
        <>
          <RefreshButton type="button" onClick={handleRefresh}>
            <FiRefreshCw size={30} />
          </RefreshButton>
        </>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          // marginLeft: 60,
          marginRight: 30,
          color: '#f2efeb',
        }}
      >
        <h1>Kultur-Kompetenz-Check</h1>
        <h2 style={{ marginBottom: '50px' }}>
          {`Du erreichst einen Gesamtscore von: ${
            currentAPillar ? Math.round(currentAPillar.score) : 'k/a'
          }`}
        </h2>
        <h3>
          <Header>
            <>
              <span>
                {currentAPillar?.name === 'Risk Culture Readiness Score'
                  ? 'Es muss eine KULTUR geschaffen werden, in der Mitarbeiter sich der Risiken des TUNS und UNTERLASSENS bewusst sind. Darüber hinaus ist es wichtig, dass sich die Risikokultur für alle Mitarbeiter „richtig“ anfühlt und sie das Thema mit einem positiven Zugang BEWERTEN.'
                  : getScoreTextKulturSelbtest(
                      Math.round(
                        currentAPillar?.score ? currentAPillar?.score : 0,
                      ),
                    ).title}
              </span>
              <p>
                {currentAPillar?.name === 'Risk Culture Readiness Score'
                  ? 'Es muss eine KULTUR geschaffen werden, in der Mitarbeiter sich der Risiken des TUNS und UNTERLASSENS bewusst sind. Darüber hinaus ist es wichtig, dass sich die Risikokultur für alle Mitarbeiter „richtig“ anfühlt und sie das Thema mit einem positiven Zugang BEWERTEN.'
                  : getScoreTextKulturSelbtest(
                      Math.round(
                        currentAPillar?.score ? currentAPillar?.score : 0,
                      ),
                    ).text}
              </p>
            </>
          </Header>
          {currentIndex > 0 && (
            <ButtonLeft type="button" onClick={handlePrev}>
              <FiChevronLeft size={60} />
            </ButtonLeft>
          )}
        </h3>
      </div>

      <Container id="containerChartKi">
        <ChartContainer
          id="chartContainerId"
          $APillarName={
            props.pinkBackground ||
            currentAPillar?.name === 'Culture Readiness Score'
              ? 'apillar1'
              : 'apillar2'
          }
          $imageBackGround={imageBackGround}
          $chartType={props.radarType}
        >
          <RadarChart
            title={
              props.resultId
                ? 'Dein Wert'
                : currentAPillar
                ? currentAPillar.name
                : 'k/a'
            }
            itens={
              currentAPillar?.topics &&
              currentAPillar.topics.flatMap((topic: Topic) => {
                return topic.name.split(' - ')[0];
              })
            }
            values={
              currentAPillar?.topics &&
              currentAPillar.topics.flatMap((topic: Topic) => {
                return Math.round(topic.score);
              })
            }
            benchmarkValues={
              currentAPillar?.name === 'Culture Readiness Score'
                ? benchmarkCRS
                : benchmarkRCRS
            }
            displayTickLabel={false}
            pinkBackground={props.pinkBackground}
          />
        </ChartContainer>
        <LegendContainer id="legend">
          <LegendItem color="#e6a04e" label="Dein Wert" />
          <LegendItem color="rgb(73, 155, 75)" label="Benchmark" />
        </LegendContainer>
        {/* <LeftContainer>
          {currentIndex !== structure.length - 1 && (
            <ButtonRight type="button" onClick={handleNext}>
              <FiChevronRight size={60} />
            </ButtonRight>
          )}
        </LeftContainer> */}
      </Container>

      <BottomContainer id="bottomContainer">
        <TextContainer id="textContainer">
          <Body>
            <HeaderLine>
              <h1>
                {currentAPillar?.name === 'Culture Readiness Score'
                  ? 'Die 5 Kultur-Dimensionen'
                  : currentAPillar?.name}
              </h1>
              <Score>
                {currentAPillar ? Math.round(currentAPillar.score) : '0'}
              </Score>
            </HeaderLine>
            {/* <SubTitle>
              <h1 style={{ fontSize: '33px', marginTop: '20px' }}>
                {'Asprägung pro Dimension:'}
              </h1>
            </SubTitle> */}
            {currentAPillar?.topics?.map((topic, i) => (
              <BodyLine
                key={i}
                $APillarName={
                  currentAPillar?.name === 'Culture Readiness Score'
                    ? 'apillar1'
                    : 'apillar2'
                }
              >
                <h3
                  style={{
                    flex: 1,
                    marginRight: '20px',
                    marginBottom: '10px',
                    fontSize: '27px',
                  }}
                >
                  {topic.name}
                </h3>
                <h3>{topic.score ? `${Math.round(topic.score)}` : '0'}</h3>
              </BodyLine>
            ))}

            <Footer>
              Der Gesamtscore setzt sich aus den 5 Kultur-Dimensionen zusammen.
            </Footer>
          </Body>
        </TextContainer>
      </BottomContainer>
    </Wrap>
  );
};

export default RadarContainer;
